import { createSlice, PayloadAction, SliceCaseReducers } from '@reduxjs/toolkit';
import { TPromoSearchTypes } from 'shared/types/promoSearchTypes';

const name = 'promoSearchTypes';

interface IPromoSearchTypesReducers extends SliceCaseReducers<TPromoSearchTypes | null> {
  setPromoSearchTypes: (
    state: TPromoSearchTypes | null,
    action: PayloadAction<TPromoSearchTypes | null>,
  ) => TPromoSearchTypes | null;
}

export const promoSearchTypesSlice = createSlice<TPromoSearchTypes | null, IPromoSearchTypesReducers, typeof name>({
  name,
  initialState: null,
  reducers: {
    setPromoSearchTypes: (_, action) => action.payload,
  },
});

export const { setPromoSearchTypes } = promoSearchTypesSlice.actions;
export const { reducer: promoSearchTypesReducer, name: promoSearchTypesReducerName } = promoSearchTypesSlice;
